export default "__VITE_ASSET__B2pnFu7O__"